<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11aGlmf/tc-custom/9781399096362.jpg?1726617300445" alt="This image is the cover for the book Fighting Napoleon at Home"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fighting Napoleon at Home
      </h1>
      <p class="bookDescription body article font2">
        <p>From the sun-baked sierras of Spain, through the stormy waters off Cape Trafalgar to the muddy and bloody fields of Waterloo, Britain’s soldiers and sailors were notching up victories which set the country on the path to becoming the greatest power on the planet. We like to imagine the country was unified against a common enemy, France, and the Tyrant of Europe – Napoleon. Yet if we scratch the surface, we find a nation not just at war with France but with itself.  The great successes of Wellington and Nelson, and the glamour of Regency London, cover over the cracks of a divided society, of riots across the industrial north and widespread political opposition. Huge swathes of the country hated the war, booed and hissed at soldiers and ‘lobbed turds’ at the Scots Greys in Halifax. There were repeated ‘Peace Petitions’ which sought to stop the war – and even to prevent the British Army fighting at Waterloo.  Armed Associations of gentlemen volunteers and Local Militias led the call to close down the debate on social and democratic reform, while on the other hand thousands of English reformers heeded the call from France and hundreds actually headed to France, with many thousands more believing that the time had come, when its young men were needed to fight for King and Country, for reform.  The burgeoning middle class had no vote in parliament; rapidly expanding industrial towns and cities had no MPs, yet small villages – pocket boroughs – often had two. The burden of taxation fell on those least able to afford it; enclosure of common land; corn laws; restrictions on the freedom of expression; the endless killing, all fed into an undercurrent of political dissent that was ideologically opposed to the loyalist cause. It was a battle for the very sole of Britain.  For the first time, the shocking reality of life in Britain, during what is often portrayed as being its greatest era, is told through diaries, letters, and newspaper comments. Fighting Napoleon at Home is a startling portrayal of the society from which the soldiers and sailors were drawn and exactly what it was they were fighting to defend. It will become essential reading for anyone attempting to understand why Britain’s aristocracy had to stop Napoleon at any cost and suppress the dangerous ideals of liberté, égalité, fraternité.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul L. Dawson
      </h2>
      
      <p class="authorDescription body article">Paul L. Dawson BSc Hons MA, MIFA, FINS, is a historian, field archaeologist and author who has written more than twenty books, his specialty being the French Army of the Napoleonic Wars. As well as speaking French and having an in-depth knowledge of French archival sources, Paul is also an historical tailor producing museum-quality replica clothing, the study of which has given him a unique understanding of the Napoleonic era.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?003ec89c